import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "@/components/Navbar";
import { api, formatApiErrorDetail } from "@/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-onyx-900 grain relative" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        className="w-full max-w-sm rounded-2xl border border-white/10 bg-onyx-800 p-8">
        <div className="flex justify-center"><Logo compact /></div>
        <h1 className="mt-5 text-center font-serif text-2xl text-slate-50">Admin Portal</h1>
        <p className="mt-1 text-center text-xs text-slate-500 font-mono uppercase tracking-[0.2em]">T&amp;T Travels</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email" data-testid="admin-email-input" className="input-dark" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" data-testid="admin-password-input" className="input-dark" />
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
            className="w-full rounded-full bg-gold py-3.5 text-sm font-semibold text-onyx-900 hover:bg-gold-light transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
